var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui four column stackable grid",
    attrs: {
      "id": "app"
    }
  }, [(_vm.showModal) ? _c('intro-modal', {
    on: {
      "closeModal": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('pin-diagram')], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('memory')], 1), _vm._v(" "), _c('div', {
    staticClass: "center aligned column"
  }, [_c('router-view', {
    staticClass: "ui basic segment"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('editor')], 1)])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "middle aligned center aligned column"
  }, [_c('h2', {
    staticClass: "ui header"
  }, [_vm._v("Pin Diagram")])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned center aligned column"
  }, [_c('h2', {
    staticClass: "ui header"
  }, [_vm._v("Memory")])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned center aligned column"
  }, [_c('h2', {
    staticClass: "ui header"
  }, [_vm._v("Peripherals")])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned center aligned column"
  }, [_c('h2', {
    staticClass: "ui header"
  }, [_vm._v("Editor")]), _vm._v(" "), _c('div', {
    staticClass: "ui stackable labels"
  }, [_c('span', {
    staticClass: "ui green label"
  }, [_vm._v("Current line")]), _vm._v(" "), _c('span', {
    staticClass: "ui blue label"
  }, [_vm._v("Next line (PC)")]), _vm._v(" "), _c('span', {
    staticClass: "ui red label"
  }, [_vm._v("Error line")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1609490c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 107
// module chunks = 1